import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 待機者 API 操作クラス
 */
export default class Followers {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET Followers
   */
  public async gets(userStore: LoginUser, queryParams?: { startIndex?: number; endIndex?: number }): Promise<Array<FollowersGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.Followers, formatParams);
    const params: any = queryParams ? queryParams : {};
    const response = await this.commonService.executeGet<Array<FollowersGetModel>>(userStore, requestUrl, this.constructor.name, params, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface FollowersGetModel {
  /** 施設を示す ID */
  facilityId: number;
  /** 宛先（LINEID または メールアドレス） */
  address: string;
  /** 宛先種別 */
  addressType: AddressType;
  /** 氏名 */
  name: string | null;
  /** 電話番号 */
  tel: string | null;
  /** 最終返信日時 */
  latestReplyDatetime: number;

  /** 論理削除フラグ */
  deleteFlag: boolean;
  /** 最終更新日 */
  updated: number;
  /** 作成した日付(YYYYMMDDhhmmssSSS) */
  created: number;
}

export enum AddressType {
  LINE = "line",
  MAIL = "mail"
}
